"use client";

import type { ReactNode } from "react";
import { Trophy } from "lucide-react";

interface HuntSubmissionsSectionProps {
  count: number;
  children: ReactNode;
}

export function HuntSubmissionsSection({ count, children }: HuntSubmissionsSectionProps) {
  return (
    <section aria-labelledby="hunt-submissions-heading">
      <div className="mb-4 flex w-full max-w-md items-center gap-3 sm:max-w-none">
        <div className="h-px min-w-[2rem] flex-1 bg-gradient-to-r from-transparent via-muted-foreground/35 to-muted-foreground/20" />
        <div className="flex shrink-0 items-center gap-2 rounded-full border border-border bg-muted/40 px-3.5 py-2 backdrop-blur-sm">
          <Trophy
            className="h-4 w-4 shrink-0 text-green-600 dark:text-green-400"
            strokeWidth={2}
            aria-hidden
          />
          <h3
            id="hunt-submissions-heading"
            className="text-base font-semibold tracking-tight text-foreground"
          >
            Your submissions
          </h3>
          <span className="rounded-full bg-green-500/15 px-2 py-0.5 text-xs font-bold tabular-nums text-green-800 dark:text-green-300">
            {count}
          </span>
        </div>
        <div className="h-px min-w-[2rem] flex-1 bg-gradient-to-l from-transparent via-muted-foreground/35 to-muted-foreground/20" />
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">{children}</div>
    </section>
  );
}
